module.exports = __webpack_public_path__ + "static/media/MaheshKatakam.abe7b2a9.jpeg";